export const ADDITIONAL_CONDITION_STATES = {
  AVAILABLE: 'AVAILABLE',
  AVAILABLE_FOR_REFILL: 'AVAILABLE_FOR_REFILL',
  LOCKED: 'LOCKED',
  LOCKED_BEFORE_CONSULT: 'LOCKED_BEFORE_CONSULT',
  LOCKED_WAITING_REFILL: 'LOCKED_WAITING_REFILL',
  REQUEST_SUBMITTED: 'REQUEST_SUBMITTED',
  PRESCRIPTION_ISSUED: 'PRESCRIPTION_ISSUED',
} as const;

export type AdditionalConditionCardState =
  (typeof ADDITIONAL_CONDITION_STATES)[keyof typeof ADDITIONAL_CONDITION_STATES];

export type AdditionalConditionName = 'ed' | 'pe' | 'hair_loss' | 'hsv';

export type AdditionalConditionItem = {
  id: string;
  conditionName: AdditionalConditionName;
  state: AdditionalConditionCardState;
};
